import { render, staticRenderFns } from "./targetgroup_details.vue?vue&type=template&id=decc907e&"
import script from "./targetgroup_details.vue?vue&type=script&lang=js&"
export * from "./targetgroup_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports